<template>
	<scoped-overflow-layout>
		<template #toolbar>
			<v-toolbar flat dense color="white">
				<bar-nav-back @navBack="navBack" />
			</v-toolbar>
		</template>

		<h3>{{ $t('ERROR_PAGE_TITLE') }}</h3>
		
	</scoped-overflow-layout>
</template>


<script>
import ScopedOverflowLayout from "@/layouts/ScopedOverflowLayout.vue";
import BarNavBack from "@/components/BarNavBack.vue";

export default {
	name: "home",
	components: { ScopedOverflowLayout, BarNavBack },
	methods: {
		navBack() {
			this.$router.go(-1);
		},
	},
};
</script>
